/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_field_density = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Density (g/mL)`)
};

const es_norm_field_density = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Densidad (g/mL)`)
};

const de_norm_field_density = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dichte (g/mL)`)
};

const nl_norm_field_density = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dichtheid (g/mL)`)
};

const fr_norm_field_density = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Densité (g/mL)`)
};

const it_norm_field_density = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Densità (g/mL)`)
};

const pt_br2_norm_field_density = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Densidade (g/mL)`)
};

const pt_norm_field_density = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Densidade (g/mL)`)
};

const ja_norm_field_density = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密度 (g/mL)`)
};

const zh_norm_field_density = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密度（g/mL）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_field_density = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_field_density(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_field_density", locale)
	if (locale === "en") return en_norm_field_density(inputs)
	if (locale === "es") return es_norm_field_density(inputs)
	if (locale === "de") return de_norm_field_density(inputs)
	if (locale === "nl") return nl_norm_field_density(inputs)
	if (locale === "fr") return fr_norm_field_density(inputs)
	if (locale === "it") return it_norm_field_density(inputs)
	if (locale === "pt-BR") return pt_br2_norm_field_density(inputs)
	if (locale === "pt") return pt_norm_field_density(inputs)
	if (locale === "ja") return ja_norm_field_density(inputs)
	return zh_norm_field_density(inputs)
};